import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'web-ui-components/lib/organisms/cards';
import { ToggleOption } from 'web-ui-components/lib/molecules/toggle';
import { Icon } from 'web-ui-components/lib/atoms/iconography';
import { isAccountCMAElligible } from '../../businessLogic/AccountsBL';
import { ARRANGED, UNARRANGED } from '../../../src/constants/StringConstants';
import { Divider } from 'web-ui-components/lib/atoms/layout';
import { SubHeading } from 'web-ui-components/lib/typography/headings';

// eslint-disable-next-line complexity
export const CMAAlertCard = ({
  toggleChange,
  brandID,
  CMAAlert,
  content,
  accountDetails,
  arrangedOverdraft,
  ifOverdraftAvailable,
}) => {
  const { CMATitle, CMATextBody, handyAlerts, CMAInfoText, arrangedOverdraftTextBody } = content;
  return (
    <div>
      {isAccountCMAElligible(accountDetails) && (
        <Card bordered className="u-margin-bottom-2">
          {ifOverdraftAvailable && (
            <ToggleOption
              active={arrangedOverdraft}
              blurb={arrangedOverdraftTextBody}
              icon={
                brandID !== 'VM' && (
                  <Icon
                    iconType="AbroadOutlineLarge"
                    className="c-a-button__icon"
                    direction="right"
                  />
                )
              }
              title={CMATitle}
              popoverOptions={{ content: <p>{CMAInfoText}</p> }}
              onChange={() => toggleChange(ARRANGED)}
            />
          )}
          {ifOverdraftAvailable && <Divider className="u-margin-bottom-0 u-margin-top-2" />}
          <ToggleOption
            active={CMAAlert}
            blurb={CMATextBody}
            onChange={() => toggleChange(UNARRANGED)}
            icon={
              !ifOverdraftAvailable &&
              brandID !== 'VM' && (
                <Icon
                  iconType="AbroadOutlineLarge"
                  className="c-a-button__icon"
                  direction="right"
                />
              )
            }
            title={!ifOverdraftAvailable && CMATitle}
            popoverOptions={!ifOverdraftAvailable && { content: <p>{CMAInfoText}</p> }}
          />
        </Card>
      )}
      <SubHeading>{handyAlerts}</SubHeading>
    </div>
  );
};

CMAAlertCard.propTypes = {
  brandID: PropTypes.string,
  content: PropTypes.shape({
    CMATitle: PropTypes.string,
    CMATextBody: PropTypes.string,
    handyAlerts: PropTypes.string,
    CMAInfoText: PropTypes.string,
    arrangedOverdraftTextBody: PropTypes.string,
  }),
  toggleChange: PropTypes.func,
  CMAAlert: PropTypes.bool,
  accountDetails: PropTypes.shape({}),
  arrangedOverdraft: PropTypes.bool,
  ifOverdraftAvailable: PropTypes.bool,
};
